// extracted by mini-css-extract-plugin
module.exports = {"customBtnContainer":"-custom-button-customBtnContainer-LU4dV2-","customBtnTitle":"-custom-button-customBtnTitle-pVcbHu-"};